export default __webpack_public_path__ + "static/media/truffle.993adda1.png";